import React from "react";
import { Button, Container, Checkbox, TextField, Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import PDF from "appearance/assets/pdf-reviewer";
import { P1, P2, P3 } from 'assets/fonts';

class ICF extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      email: "",
      show: false
    }
  }

  handleChange = (index) => {
    const { checked1, checked2, checked3, checked4, checked5, checked6, checked7 } = this.state;
    switch (index) {
      case 1:
        return this.setState({ checked1: !checked1 });
      case 2:
        return this.setState({ checked2: !checked2 });
      case 3:
        return this.setState({ checked3: !checked3 });
      case 4:
        return this.setState({ checked4: !checked4 });
      case 5:
        return this.setState({ checked5: !checked5 });
      case 6:
        return this.setState({ checked6: !checked6 });
      case 7:
        return this.setState({ checked7: !checked7 });
      default:
        return null;
    }
  }

  handleShowConsents = () => {
    if (!this.state.show) this.setState({ show: true });
  }

  render() {
    const { checked1, checked2, checked3, checked4, checked5, checked6, checked7, show } = this.state;
    return (
      <Container>
        <div>
          <br />
          <div id="icf">
            <div style={{ marginLeft: "10%", marginRight: "10%" }}>
              <P2>Tips: If you think the size of PDF is small, please increase the width of your browser and reload/refresh the page.</P2>
              <P2>Instructions: Please read the two-page information sheet below and complete the
                checkbox questions on the second page to consent to participate in this study.</P2>
            </div>

            <PDF file={process.env.PUBLIC_URL + "/appearance/docs/consent.pdf"} showConsents={this.handleShowConsents} />
          </div>
          <br />
          {
            show ?
              <div id="consents">
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>1. Do you understand that you have been asked to be in a research study?</P2>
                  <Checkbox
                    checked={checked1}
                    color="primary"
                    onChange={() => this.handleChange(1)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  <P2 style={{ marginTop: 9 }}>Yes</P2>
                </div>
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>2. Have you read the information at the top of this page?</P2>
                  <Checkbox
                    checked={checked2}
                    color="primary"
                    onChange={() => this.handleChange(2)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  <P2 style={{ marginTop: 9 }}>Yes</P2>
                  <a href={process.env.PUBLIC_URL + "/appearance/docs/consent.pdf"} target="_blank" style={{ marginTop: 7, marginLeft: 10, color: "#107896" }}>
                    A copy of this information can be downloaded here
                  </a>
                </div>
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>3. Do you understand the benefits and risks involved in taking part in this research study?</P2>
                  <Checkbox
                    checked={checked3}
                    color="primary"
                    onChange={() => this.handleChange(3)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  <P2 style={{ marginTop: 9 }}>Yes</P2>
                </div>
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>
                    4. Do you understand that you are free to withdraw from this study at any time without having to give a reason?
                  </P2>
                  <Checkbox
                    checked={checked4}
                    color="primary"
                    onChange={() => this.handleChange(4)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  <P2 style={{ marginTop: 9 }}>Yes</P2>
                </div>
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>5. Do you understand that your confidentiality and anonymity will be protected at all times?</P2>
                  <Checkbox
                    checked={checked5}
                    color="primary"
                    onChange={() => this.handleChange(5)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  <P2 style={{ marginTop: 9 }}>Yes</P2>
                </div>
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>6. Do you understand that are free to contact the researchers (jcbhlab@ualberta.ca) if you have any questions about this study?</P2>
                  <Checkbox
                    checked={checked6}
                    label="asdasdasda"
                    color="primary"
                    onChange={() => this.handleChange(6)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  <P2 style={{ marginTop: 9 }}>Yes</P2>
                </div>
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>7. If you wish to be contacted about future studies, please enter your email here:</P2>
                  <TextField style={{ marginTop: 3, marginLeft: 5, width: 200 }} onChange={(e) => this.setState({ email: e.target.value })} />
                </div>
                <div className="row" style={{ marginLeft: 20 }}>
                  <P2 style={{ marginTop: 10 }}>8. I agree to take part in this study:</P2>
                  <RadioGroup aria-label="gender" name="gender1" value={checked7} onChange={() => this.handleChange(7)}>
                    <div className="row" style={{ marginLeft: 10 }}>
                      <FormControlLabel value={true} control={<Radio color="primary" />} label="Yes" />
                      <FormControlLabel value={false} control={<Radio />} label="No" />
                    </div>
                  </RadioGroup>
                </div>
                {
                  checked1 && checked2 && checked3 && checked4 && checked5 && checked6 && checked7 ?
                    <Button
                      variant="contained"
                      size="large"
                      style={{ margin: 20, width: 150, color: "white", backgroundColor: "#107896" }}
                      onClick={() => this.props.handleClick(this.state.email)}
                    >
                      Next
                    </Button>
                    :
                    <div><Button
                      variant="contained"
                      size="large"
                      disabled
                      style={{ margin: 20, width: 150, color: "white", backgroundColor: "#107896" }}
                    >
                      Next
                    </Button>
                      <P3>You cannot progress to the next step because you have not completed the consent questions.</P3>
                    </div>
                }
              </div>
              :
              null
          }
          <br /><br /><br /><br /><br /><br />
        </div>
      </Container>
    )
  }
}

export default ICF;
